import { type ReactNode, memo, useEffect, useRef } from 'react'

import { HcStructure } from '@hotmart-org-ca/cosmos-web/dist/react/hc-structure'
import { css } from 'styled-components'

type StructureProps = {
  children: ReactNode
  className?: string
  isViewAsEnabled?: boolean
}

const structureStyles = css`
  .hc-structure {
    margin-top: 5.125rem;
  }
`

const Structure = ({ children, className, isViewAsEnabled = false }: StructureProps) => {
  const structureRef = useRef<HTMLHcStructureElement>(null)

  useEffect(() => {
    if (!structureRef?.current) {
      return
    }

    const styles = document.createElement('style')
    const shadowRoot = structureRef.current?.shadowRoot

    if (isViewAsEnabled) {
      styles.id = 'custom-structure-styles'
      styles.innerHTML = structureStyles.toString()
      shadowRoot?.prepend(styles)
    }

    return () => {
      styles.remove()
    }
  }, [isViewAsEnabled])

  return (
    <HcStructure ref={structureRef} class={className}>
      {children}
    </HcStructure>
  )
}

export default memo(Structure)
